import { mapCompanyType, useFindCompanySuspense } from '@api';
import { BankAccounts, useBankAccountMutations } from '@common';
import { usePermissionContext } from '@hypeit-gmbh/hypeit-ui-core';
import { Route } from 'src/routes/_rootLayout/companies/$id.finance';
import { useCreateCompanyBankAccount } from './hooks';

export const CompanyBankAccounts: React.FC = () => {
  const { id } = Route.useParams();
  const { data: company } = useFindCompanySuspense(id, {
    query: { select: (response) => mapCompanyType(response.data) },
  });

  const { hasPermission } = usePermissionContext();
  const userCanEditFinance = hasPermission({
    permission: 'FINANCE',
    action: 'WRITE',
  });

  const { submitCreateBankAccount } = useCreateCompanyBankAccount(company.id);
  const {
    submitUpdateBankAccount,
    submitDeleteBankAccount,
    handleApproveBankAccount,
    isDeletePending,
  } = useBankAccountMutations();

  return (
    <div data-testid="company-bank-accounts-card">
      <BankAccounts
        bankAccounts={company.bankAccounts}
        canEdit={userCanEditFinance}
        onSubmitCreate={submitCreateBankAccount}
        onSubmitUpdate={submitUpdateBankAccount}
        onSubmitDelete={submitDeleteBankAccount}
        onApprove={handleApproveBankAccount}
        isDeletePending={isDeletePending}
      />
    </div>
  );
};
